<template>
  <v-container fluid class="app-container ma-0 pa-0">
    <v-row no-gutters class="ma-0 pa-0">
      <div v-if="!$vuetify.breakpoint.xs" class="side-bar-col ma-0 pa-0 d-flex flex-column">
        <div style="height: 15vh; width: auto;" class="d-flex flex-column justify-center align-start pl-8">
          <router-link to="/">
            <img :src="logo" alt="company logo" class="logo" />
          </router-link>
        </div>
        <div class="px-4">
          <side-menu />
        </div>
      </div>
      <div
          class="content-section ma-0 pa-0"
          :style="{
            width: `${$vuetify.breakpoint.xs ? '100%' : '85%' } !important`,
            marginLeft: `${$vuetify.breakpoint.xs ? '0' : '15%' } !important`
          }"
      >
        <v-row no-gutters class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <Navigation
                @logout="showLogOutDialog = true"
                @onClickAppBarIcon="drawerOpen = !drawerOpen"
                width="85%"
                v-if="!$vuetify.breakpoint.xs"
            />
            <MobileNavBar v-else/>
          </v-col>
          <v-col
              cols="12"
              class="mx-0 py-6 px-sm-6"
              :style="{ width: '100vh', marginTop: $vuetify.breakpoint.xs ? '8vh' : '' }"
          >
            <router-view></router-view>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Navigation from "@/components/Navigation";
import SideMenu from "@/components/SideMenu";
import logo from "@/assets/logo-white.svg";
import MobileNavBar from "@/components/MobileNavBar";

export default {
  name: "NavBarSideBar",
  components: {MobileNavBar, SideMenu, Navigation},
  data: function () {
    return {
      logo,
      showLogOutDialog: false,
      drawerOpen: true,
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #EAEFF9;
  display: flex;
  flex-direction: column;

  .side-bar-col {
    width: 15% !important;
    background-color: #0033AA;
    height: 100%; /* Full-height: remove this if you want "auto" height */
    position: fixed; /* Fixed Sidebar (stay in place on scroll) */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    left: 0;
    overflow-x: hidden;

    .logo {
      width: 80px;
      height: 80px;
    }
  }

  .content-section {
    min-height: 100vh;
    background-color: #EAEFF9;
    display: flex;
    flex-direction: column;
  }
}

</style>
